// export const BASE_URL = 'http://localhost:8000';
// export const BASE_URL = 'http://192.168.213.28:8000';
export const BASE_URL = 'https://motionindonesia.com';
// export const BASE_URL = '';
export const ASSET_URL = BASE_URL + '/assets/';
